enum StepperType {
  L = 'L',
  M = 'M',
  S = 'S',
}

export default StepperType;
